import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

export const EmptyState = ({ icon: Icon = Inbox, title, body, action, className, testid = "empty-state" }) => (
  <div data-testid={testid} className={cn("flex flex-col items-start gap-3 rounded-2xl border border-dashed bg-card/60 px-6 py-10", className)}>
    <span className="grid h-12 w-12 place-items-center rounded-full" style={{ background: "color-mix(in srgb, hsl(var(--action)) 16%, transparent)" }}>
      <Icon className="text-action" aria-hidden="true" />
    </span>
    <h2 className="text-base font-semibold">{title}</h2>
    {body && <p className="max-w-md text-sm text-muted-foreground">{body}</p>}
    {action}
  </div>
);

export const ErrorState = ({ message, onRetry, testid = "error-state" }) => (
  <div role="alert" data-testid={testid} className="rounded-xl border border-destructive/40 bg-destructive/5 px-6 py-6">
    <p className="text-sm font-medium text-foreground">{message}</p>
    {onRetry && (
      <button type="button" onClick={onRetry} className="mt-3 text-sm font-medium underline underline-offset-4" data-testid={`${testid}-retry`}>
        Try again
      </button>
    )}
  </div>
);
